<script setup>
    import { computed, ref } from 'vue';
    import Image from '@/components/Image.vue';

    const props = defineProps(['step', 'customer']);
    const emit = defineEmits(['select-option']);

    // Track which swatch is being hovered
    const hoveredOptionId = ref(null);

    const filteredOptions = computed(() => {
        return props.step.options.filter(option => {
            return !option.tradeOnly || (option.tradeOnly && props.customer.isTradeProfessional.value == true);
        });
    });

    // Compute unique categories from filtered options
    const categories = computed(() => {
        return new Set(filteredOptions.value.map(option => option.category));
    });

    // Get options for a specific category
    function categoryOptions(category) {
        return filteredOptions.value.filter(option => option.category === category);
    }
</script>

<template>
    <a class="config-item__help-link" href="/swatches">
        <Image class="step__help-link-icon icon icon--left" src="icon-swatch.svg" />
        <div class="step__help-link-text">
            Order Swatch Samples
        </div>
    </a>
    <div v-for="(category, category_index) in categories" :key="category_index">
        <div class="option-category-heading">{{ category }}</div>
        <!-- <BButton class="step-option swatch swatch-toggle" 
            v-for="(option, option_index) in categoryOptions(category)" :key="option_index"     
            :title="option.label"
            :class="{ 'active': step.selected.value.id === option.id }"
            @click="emit('select-option', step, option)"
            :disabled="option.disabled && option.disabled.value" >
                <Image :src="option.image" />
        </BButton> -->
        <div class="swatch-group">
            <div class="swatch-wrapper" 
                v-for="(option, option_index) in categoryOptions(category)" 
                :key="option_index"
                @mouseenter="hoveredOptionId = option.id"
                @mouseleave="hoveredOptionId = null"
            >
                <BButton class="step-option swatch swatch-toggle"
                    :class="{ 'active': step.selected.value.id === option.id }"
                    @click="emit('select-option', step, option)"
                    :disabled="option.disabled && option.disabled.value" >
                        <Image :src="option.image" />
                </BButton>

                <!-- Tooltip -->
                <div v-if="hoveredOptionId === option.id" class="swatch-tooltip">
                    {{ option.label }}
                </div>
            </div>
        </div>
    </div>
</template>